import { c as _c } from "react/compiler-runtime";
import React from "react";
import WebUnifiedWavesList from "./WebUnifiedWavesList";
import { useMyStream } from "../../../../contexts/wave/MyStreamContext";
interface WebBrainLeftSidebarWavesProps {
  readonly scrollContainerRef: React.RefObject<HTMLElement | null>;
  readonly isCollapsed?: boolean | undefined;
  readonly showProfileFeedShortcut?: boolean | undefined;
}
const WebBrainLeftSidebarWaves: React.FC<WebBrainLeftSidebarWavesProps> = t0 => {
  const $ = _c(12);
  const {
    scrollContainerRef,
    isCollapsed: t1,
    showProfileFeedShortcut: t2
  } = t0;
  const isCollapsed = t1 === undefined ? false : t1;
  const showProfileFeedShortcut = t2 === undefined ? true : t2;
  const {
    waves,
    registerWave
  } = useMyStream();
  let t3;
  if ($[0] !== waves) {
    t3 = () => {
      if (waves.hasNextPage && !waves.isFetchingNextPage && !waves.isFetching) {
        waves.fetchNextPage();
      }
    };
    $[0] = waves;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const onNextPage = t3;
  let t4;
  if ($[2] !== isCollapsed || $[3] !== onNextPage || $[4] !== registerWave || $[5] !== scrollContainerRef || $[6] !== showProfileFeedShortcut || $[7] !== waves.hasNextPage || $[8] !== waves.isFetching || $[9] !== waves.isFetchingNextPage || $[10] !== waves.list) {
    t4 = <WebUnifiedWavesList waves={waves.list} fetchNextPage={onNextPage} hasNextPage={waves.hasNextPage} isFetching={waves.isFetching} isFetchingNextPage={waves.isFetchingNextPage} onHover={registerWave} scrollContainerRef={scrollContainerRef} isCollapsed={isCollapsed} showProfileFeedShortcut={showProfileFeedShortcut} />;
    $[2] = isCollapsed;
    $[3] = onNextPage;
    $[4] = registerWave;
    $[5] = scrollContainerRef;
    $[6] = showProfileFeedShortcut;
    $[7] = waves.hasNextPage;
    $[8] = waves.isFetching;
    $[9] = waves.isFetchingNextPage;
    $[10] = waves.list;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default WebBrainLeftSidebarWaves;